interface RecruitCardProps {
  recruit: {
    id: string
    player_name: string
    position?: string
    club?: string
    state?: string
    ranking?: number
    class_year?: number
    committed_school?: string
    committed_conference?: string
  }
}

export function RecruitCard({ recruit }: RecruitCardProps) {
  return (
    <div className="card p-4 hover:border-accent/30 transition-colors">
      <div className="flex items-start justify-between mb-2">
        <div>
          <h3 className="text-sm font-semibold text-white">{recruit.player_name}</h3>
          <div className="flex items-center gap-2 mt-0.5">
            {recruit.position && <span className="text-xs text-accent">{recruit.position}</span>}
            {recruit.state && <span className="text-xs text-slate-500">{recruit.state}</span>}
          </div>
        </div>
        {recruit.ranking && (
          <span className="text-xs font-bold text-accent bg-accent/10 px-2 py-1 rounded">
            #{recruit.ranking}
          </span>
        )}
      </div>

      {recruit.club && (
        <p className="text-xs text-slate-400 mb-2">{recruit.club}</p>
      )}

      {recruit.committed_school ? (
        <div className="flex items-center gap-1.5 mt-2 pt-2 border-t border-pitch-700/50">
          <svg className="w-3.5 h-3.5 text-zone-safe" fill="currentColor" viewBox="0 0 20 20">
            <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
          </svg>
          <span className="text-xs text-zone-safe font-medium">{recruit.committed_school}</span>
        </div>
      ) : (
        <div className="flex items-center gap-1.5 mt-2 pt-2 border-t border-pitch-700/50">
          <span className="text-xs text-slate-500">Uncommitted</span>
        </div>
      )}
    </div>
  )
}
